// 
export const positionTypeList = [
  { name: '离职-随时到岗', value: 1 },
  { name: '在职-暂不考虑', value: 2 },
  { name: '在职-考虑机会', value: 3 },
  { name: '在职-月内到岗', value: 4 }
];

export const postTypeList = [
  { name: '核心岗位', value: 1 },
  { name: '普通岗位', value: 0 }
];

export const getPositionById = (pid) => {
  if (typeof pid !== 'number') {
    pid = Number(pid);
  }
  const result = positionTypeList.find(item => item.value === pid);
  return typeof result === 'undefined' ? '' : result.name;
};

export const getPostTypeById = (pid) => {
  if (typeof pid !== 'number') {
    pid = Number(pid);
  }
  const result = postTypeList.find(item => item.value === pid);
  return typeof result === 'undefined' ? '' : result.name;
};


// WEBPACK FOOTER //
// ./src/config/telant.js